import * as types from '../actiontypes';
import {API_RESOURCES, createApiReadAction} from '../../util/api';
import {entities} from '../../util/uiconstants';

const actionType = types.GET_TOP_ENTITY_METADATA;

const resourceKeyConfig = {
	[entities.Account]: API_RESOURCES.ACCOUNTS,
	[entities.GaComponent]: API_RESOURCES.COMPONENTS,
	[entities.STEntity]: API_RESOURCES.MULTIENTITY,
	[entities.Estimate]: API_RESOURCES.RISKS,
	[entities.SCOT]: API_RESOURCES.SCOTS
};

const getEntityResource = (engagementId, entityType, entityUid) => {
	let key = resourceKeyConfig[entityType];
	return {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[key]: entityUid
	};
};

export const getEntityMetadata = (engagementId, entityType, entityUid, mapper) => {
	return createApiReadAction(actionType, getEntityResource(engagementId, entityType, entityUid), undefined, {mapper});
};

export const getControlMetadata = (engagementId, entityUid, documentId, mapper) => {
	return createApiReadAction(
		actionType,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.CONTROL]: entityUid
		},
		{documentId},
		{mapper}
	);
};

export const getAccountMetadata = (engagementId, entityUid, documentId, mapper) => {
	return createApiReadAction(
		actionType,
		getEntityResource(engagementId, entities.Account, entityUid),
		{documentId, includeAssertions: true, includeRelatedRisks: true, includeHelix: true, includeEntities: true, includePspIndexes: true},
		{mapper, entity: entities.Account}
	);
};

export const getEstimateMetadata = (engagementId, entityUid, documentId, mapper, area = undefined) => {
	return createApiReadAction(
		actionType,
		getEntityResource(engagementId, entities.Estimate, entityUid),
		{documentId, includeAccounts: true, includeRelatedRisks: true, includeScots: true},
		{mapper, entity: entities.Estimate},
		true,
		area
	);
};
